import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

export const ActionButton = ({ tooltipText, children, ...buttonProps }) => {
    const ActionTooltip = (tooltipProps) => (
        <Tooltip id="action-tooltip" {...tooltipProps}>
            {tooltipText}
        </Tooltip>
    );

    if (!tooltipText) {
        return <button {...buttonProps}>{children}</button>;
    }

    return (
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={ActionTooltip}>
            <button {...buttonProps}>{children}</button>
        </OverlayTrigger>
    );
};
